export default {
  namespaced: true,
  local: true,
  state: {
    loginChannel: "", //tob、toc；登录渠道，记录路由name值，作用是为了退出时回到初始B端或C端
    access_token: "",
    system: "", //平台system
    systemId: 8, //平台systemId
    userId: "", // 用户id
    compId: "", // 企业id
    compName: "", // 公司简称
    userName: "",
    userFace: "", //用户（公司）头像
    userSign: "", // 用户身份标识 company企业 staff员工
    systemSign: "", // 1 hrm（甲方） 、2 hro（乙方） systemSign 为空表示没有外包业务
    staffType: "", // 1 合同 、2 外包
    module: "", // 招聘12  RPO13
    compAdmin: 0, //0不是管理员，1普通管理员，2超级管理员（注意此处描述的管理员并非权限中设置的管理员，与isAdmin和isAdminObj无任何关系）
    // 培训理论上  只要培训栏目是管理员或者超管就回事1 或者 2
    staffAdmin: 0, //0不是管理员，1普通管理员，2超级管理员  新逻辑当他是所有栏目的普通管理员时是1，所有栏目的超级管理员时是2，其他都是0
    userStaffAdmin: {}, //拥有哪些栏目的权限
    user: {
      sysType: "",
      userId: "", //登录者id
      userLoginCode: "", //
      userName: "", //登录者姓名
      userType: "", //登录者类型：2-公司；其他是员工
      vipId: "", //登录者公司id
    },
    userInfo: {},
  },
  mutations: {
    login(state, info) {
      console.log(info, "========info=============");

      if (info.system) state.system = info.system;
      if (info.systemId) state.systemId = info.systemId;
      if (info.loginChannel) state.loginChannel = info.loginChannel;
      if (info.access_token) state.access_token = info.access_token;
      if (info.userId) state.userId = info.userId;
      if (info.vipId) state.compId = info.vipId;
      if (info.compName) state.compName = info.compName;
      if (info.userName) state.userName = info.userName;
      if (info.userType)
        state.userSign = info.userType == 2 ? "company" : "staff";
      // if (info.module) state.systemSign = info.module;
      if (info.sysType) state.systemSign = info.sysType;
      if (info.staffType) state.staffType = info.staffType;
      if (info.module) state.module = info.module;
      if (info.compAdmin || info.compAdmin == 0) {
        state.compAdmin = info.compAdmin;
      }
      if (info.staffAdmin || info.staffAdmin == 0) {
        state.staffAdmin = info.staffAdmin * 1;
      }
      if (info.userStaffAdmin) state.userStaffAdmin = info.userStaffAdmin;
      if (info.user) state.user = info.user;
      if (info.userInfo) {
        state.userInfo = info.userInfo;
      }
    },
    logout(state) {
      console.log(state, "==state");
      state.access_token = "";
      state.compId = "";
      state.compName = "";
      state.userId = "";
      state.userName = "";
      state.userFace = "";
      state.userType = "";
      state.systemSign = "";
      state.staffType = "";
      state.module = "";
      state.compAdmin = 0;
      state.user = {};
      state.userInfo = {};
    },
  },
};
